import {
  CoreApi,
  MapViewBoxRequest,
  AtlasViewBoxRequest,
  RequestOptions,
  OptionsType,
} from "@hokuto/jam-core";
import { ApiMethod } from "../types.js";

export function getImageParams<T extends OptionsType>(
  args: T,
  body?: Partial<RequestOptions>
) {
  const headers = {
    ...CoreApi.Options.getRequestOptions(args),
    "Content-Type": "application/json",
  };
  const method = body ? ApiMethod.Post : ApiMethod.Get;
  return { headers, method, params: body };
}

export function getMapImageParams<T extends MapViewBoxRequest>(
  urlFn: typeof CoreApi.Map.Image,
  args: T,
  body?: Partial<RequestOptions>
) {
  return { url: urlFn(args), ...getImageParams(args, body) };
}

export function getAtlasImageParams<T extends AtlasViewBoxRequest>(
  urlFn: typeof CoreApi.Atlas.Image,
  args: T,
  body?: Partial<RequestOptions>
) {
  return { url: urlFn(args), ...getImageParams(args, body) };
}
